import api from '../../lib/api';

export const getMapData = params =>
  function get(dispatch) {
    dispatch(getMapDataLoading('loading'));
    api.getMapData(params, (error, response) => {
      if (error) {
        dispatch(getMapDataLoading('error'));
        return dispatch(getMapDataError(error));
      }
      dispatch(getMapDataLoading(''));
      return dispatch(getMapDataSuccess(response.data));
    });
  };

export const getMapDataLoading = data => ({
  type: 'GET_MAP_DATA_LOADING',
  data,
});

export const getMapDataSuccess = data => ({
  type: 'GET_MAP_DATA_SUCCESS',
  data,
});

export const getMapDataError = msg => ({
  type: 'GET_MAP_DATA_ERROR',
  msg,
});



// WEBPACK FOOTER //
// ./src/Actions/MapData/getMapData.js